"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWalletNotConnectedError = void 0;
function isWalletNotConnectedError(error) {
    return error instanceof WalletNotConnectedError;
}
exports.isWalletNotConnectedError = isWalletNotConnectedError;
//# sourceMappingURL=walletAdapter.js.map